// extracted by mini-css-extract-plugin
module.exports = {"base":"column-m__base__8OiD7","ad-slot":"column-m__ad-slot__3SIex"};